import {Card, Typography} from "antd";

export default function DashboardItem({value, text, color, secondColor, textColor}) {
    return (
        <Card
            style={{
                minWidth: 200,
                backgroundColor: color,
                color: textColor,
                borderColor: secondColor
            }}
        >
            <Typography.Title level={3}>
                {value}
            </Typography.Title>
            <Typography.Title level={5}>
                {text}
            </Typography.Title>
        </Card>
    )
}